import React from "react";
import { Link } from "react-router-dom";
import { DarkModeIconToggle } from "./shared/DarkModeToggle";

const CoverPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 relative">
        {/* Dark Mode Toggle */}
        <div className="absolute top-4 right-4">
          <DarkModeIconToggle />
        </div>
        
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-100 mb-2">
            Traveller Ship Builder
          </h1>
        </div>

        {/* Builder Selection */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-6">
            Choose Your Builder
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {/* Ship Builder */}
            <Link
              to="/ship-builder"
              className="group bg-white dark:bg-gray-700 border-2 border-orange-300 dark:border-orange-600 rounded-lg p-6 hover:border-orange-500 dark:hover:border-orange-400 hover:shadow-lg transition-all duration-200"
            >
              <div className="text-center">
                <div className="text-4xl mb-3">🚀</div>
                <h3 className="text-xl font-bold text-orange-600 dark:text-orange-400 mb-2 group-hover:text-orange-700 dark:group-hover:text-orange-300">
                  Ship Builder
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">
                  Design complete starships from hull to final configuration. 
                  Perfect for creating custom vessels for your campaigns.
                </p>
                <div className="mt-3 text-xs text-orange-500 dark:text-orange-400 font-medium">
                  Click to Start
                </div>
              </div>
            </Link>

            {/* Module Builder */}
            <Link
              to="/module-builder"
              className="group bg-white dark:bg-gray-700 border-2 border-purple-300 dark:border-purple-600 rounded-lg p-6 hover:border-purple-500 dark:hover:border-purple-400 hover:shadow-lg transition-all duration-200"
            >
              <div className="text-center">
                <div className="text-4xl mb-3">🔧</div>
                <h3 className="text-xl font-bold text-purple-600 dark:text-purple-400 mb-2 group-hover:text-purple-700 dark:group-hover:text-purple-300">
                  Module Builder
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">
                  Create modular ship components and systems. 
                  Ideal for designing reusable modules and subsystems.
                </p>
                <div className="mt-3 text-xs text-purple-500 dark:text-purple-400 font-medium">
                  Click to Start
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Required Materials Notice */}
        <div className="bg-blue-50 dark:bg-blue-900/30 border-l-4 border-blue-400 dark:border-blue-500 p-6 mb-8">
          <h2 className="text-xl font-semibold text-blue-800 dark:text-blue-200 mb-4">
            Required Materials
          </h2>
          <div className="text-sm text-blue-700 dark:text-blue-300 space-y-2">
            <p>
              <strong>To use this app effectively, you will need:</strong>
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>A copy of the <strong>Traveller 2nd Edition Rules</strong> from Mongoose Publishing</li>
              <li>A copy of the <strong>High Guard supplement</strong> from Mongoose Publishing</li>
            </ul>
            <p className="mt-3">
              The rules used herein are compliant with the updated versions of those documents (June 2023, and April 2024 respectively).
            </p>
          </div>
        </div>

        {/* Fair Use Notice */}
        <div className="bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-400 dark:border-yellow-500 p-6 mb-8">
          <h2 className="text-xl font-semibold text-yellow-800 dark:text-yellow-200 mb-4">
            Fair Use Notice
          </h2>
          <div className="text-sm text-yellow-700 dark:text-yellow-300 space-y-3">
            <p>
              <strong>The Traveller, 2300AD, Twilight: 2000 and Dark Conspiracy games in all forms are owned by Mongoose Publishing. Copyright 1977 - 2025 Mongoose Publishing. Traveller is a registered trademark of Mongoose Publishing.</strong>
            </p>
            <p>
              Mongoose Publishing permits web sites and fanzines for this game, provided it contains this notice, that Mongoose Publishing is notified, and subject to a withdrawal of permission on 90 days notice. The contents of this site are for personal, non-commercial use only.
            </p>
            <p>
              Any use of Mongoose Publishing's copyrighted material or trademarks anywhere on this web site and its files should not be viewed as a challenge to those copyrights or trademarks. In addition, any program/articles/file on this site cannot be republished or distributed without the consent of the author who contributed it.
            </p>
            <p className="mt-4">
              For the complete Fair Use Policy, visit: <a href="https://www.mongoosepublishing.com" className="underline hover:text-yellow-800 dark:hover:text-yellow-200" target="_blank" rel="noopener noreferrer">Mongoose Publishing</a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-600 text-center">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            This tool is provided as-is for personal, non-commercial use only. 
            Always refer to the official Mongoose Publishing rulebooks for complete rules and guidelines.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoverPage;
